<template>
  <CCol cols="6" xl="6" lg="6" md="6" sm="12" class="latest posts">
    <CCard class="leaderboard mb-0 h-100">
      <CCardHeader class="pb-0">
        {{$t('loyalty.Leaderboard_moments_received')}}
      </CCardHeader>
      <CCardBody class="has_tabs pb-0">
        <CRow>     
          <CCol cols="12" class="p-0">
            <b-tabs class="points_leaderboard no_borders mb-0"
                    type="is-boxed"
                    :animated="false"
                    v-model="activeTab"
                    @input="currentPage = 1;"
                    v-bind:class="{'remove_bottom_content_padding' : (activeTab === 0 && !momentsReceivedLastMonthPaginated) || (activeTab === 1 && !momentsReceivedLastThreeMonthsPaginated) || (activeTab === 2 && !momentsReceivedLastYearPaginated)}">
            
              <b-tab-item>
                <template slot="header">
                  <span>{{ $t('loyalty.Moments_received') }} - {{ $t('common.last_30_days')}}</span>
                </template>
                <template>
                  <CRow>
                    <CCol cols="12" lg="12" class="p-0">
                      <loadingSpinner mode="auto" v-if="loadingData" :content="$t('common.Loading')"/>
                      <b-table v-else
                               class="data_table"
                               :data="momentsReceivedLastMonth"
                               :striped="true"
                               :hoverable="true"
                               :mobile-cards="true"
                               :paginated="momentsReceivedLastMonthPaginated"
                               :per-page="perPage"
                               :current-page.sync="currentPage"
                               :pagination-simple="isPaginationSimple"
                               :pagination-position="paginationPosition">
                        
                        <template slot-scope="props">
                          <b-table-column field="position" width="5%">
                            <b>#{{props.row.position}}</b>
                          </b-table-column>
                          <b-table-column field="name" :label="$t('common.Name')" width="45%">
                            <div class="d-flex align-items-center">
                              <userProfilePopover ref="userProfilePopover"
                                                  mode="user" 
                                                  :userName="props.row.name"
                                                  :userProfileImage="props.row.profile_image" 
                                                  :userIdExternal="props.row.user_id_external"
                                                  :senderIdExternal="null"
                                                  popoverPlacement="right"
                                                  :triggerAvatarSize="25"
                                                  class="mr-2">
                              </userProfilePopover>
                              <div>
                                <span>{{props.row.name}}</span>
                                <span class="d-block mt-1 meta">{{props.row.team_name}} - {{props.row.department_name}}</span>
                              </div>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_moments" :label="$t('loyalty.Moments_received')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/loyalty-moment-icon/common/spark.png/' + clientToken"/>
                              <span>{{props.row.total_moments}} {{props.row.total_moments !== 1 ? $t('sm.Sparks') : $t('sm.Spark')}}</span>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_points_received" :label="$t('loyalty.Coins_received')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/base-dashboard/credits/' + environmentTag + '_credit.png/' + clientToken"/>
                              <span>{{props.row.total_points_received}} {{props.row.total_points_received !== 1 ? $t('common.coins') : $t('common.coin')}}</span>
                            </div>                            
                          </b-table-column>                          
                        </template>
                        <template slot="empty">
                          <div class="text-center">
                            <span>{{ $t('sm.No_sparks_sent_yet') }}</span>
                          </div>
                        </template>
                      </b-table>
                    </CCol>
                  </CRow>
                </template>
              </b-tab-item>
              <b-tab-item>
                <template slot="header">
                  <span>{{ $t('loyalty.Moments_received') }} - {{ $t('common.last_90_days')}}</span>
                </template>
                <template>
                  <CRow>
                    <CCol cols="12" lg="12" class="p-0">
                      <loadingSpinner mode="auto" v-if="loadingData" :content="$t('common.Loading')"/>
                      <b-table v-else 
                               class="data_table"
                               :data="momentsReceivedLastThreeMonths"
                               :striped="true"
                               :hoverable="true"
                               :mobile-cards="true"
                               :paginated="momentsReceivedLastThreeMonthsPaginated"
                               :per-page="perPage"
                               :current-page.sync="currentPage"
                               :pagination-simple="isPaginationSimple"
                               :pagination-position="paginationPosition">
                        
                        <template slot-scope="props">
                          <b-table-column field="position" width="5%">
                            <b>#{{props.row.position}}</b>
                          </b-table-column>
                          <b-table-column field="name" :label="$t('common.Name')" width="45%">
                            <div class="d-flex align-items-center">
                              <userProfilePopover ref="userProfilePopover"
                                                  mode="user" 
                                                  :userName="props.row.name"
                                                  :userProfileImage="props.row.profile_image" 
                                                  :userIdExternal="props.row.user_id_external"
                                                  :senderIdExternal="null"
                                                  popoverPlacement="right"
                                                  :triggerAvatarSize="25"
                                                  class="mr-2">
                              </userProfilePopover>
                              <div>
                                <span>{{props.row.name}}</span>
                                <span class="d-block mt-1 meta">{{props.row.team_name}} - {{props.row.department_name}}</span>
                              </div>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_moments" :label="$t('loyalty.Moments_received')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/loyalty-moment-icon/common/spark.png/' + clientToken"/>
                              <span>{{props.row.total_moments}} {{props.row.total_moments !== 1 ? $t('sm.Sparks') : $t('sm.Spark')}}</span>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_points_received" :label="$t('loyalty.Coins_received')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/base-dashboard/credits/' + environmentTag + '_credit.png/' + clientToken"/>
                              <span>{{props.row.total_points_received}} {{props.row.total_points_received !== 1 ? $t('common.coins') : $t('common.coin')}}</span>
                            </div>                            
                          </b-table-column>                          
                        </template>
                        <template slot="empty">
                          <div class="text-center">
                            <span>{{ $t('sm.No_sparks_sent_yet') }}</span>
                          </div>
                        </template>                
                      </b-table>
                    </CCol>
                  </CRow>
                </template>
              </b-tab-item>
              <b-tab-item>
                <template slot="header">
                  <span>{{ $t('loyalty.Moments_received') }} - {{ $t('common.last_365_days')}}</span>
                </template>
                <template>
                  <CRow>
                    <CCol cols="12" lg="12" class="p-0">
                      <loadingSpinner mode="auto" v-if="loadingData" :content="$t('common.Loading')"/>
                      <b-table v-else
                               class="data_table"
                               :data="momentsReceivedLastYear"
                               :striped="true"
                               :hoverable="true"
                               :mobile-cards="true"
                               :paginated="momentsReceivedLastYearPaginated"
                               :per-page="perPage"
                               :current-page.sync="currentPage"
                               :pagination-simple="isPaginationSimple"
                               :pagination-position="paginationPosition">
                        
                        <template slot-scope="props">
                          <b-table-column field="position" width="5%">
                            <b>#{{props.row.position}}</b>
                          </b-table-column>
                          <b-table-column field="name" :label="$t('common.Name')" width="45%">
                            <div class="d-flex align-items-center">
                              <userProfilePopover ref="userProfilePopover"
                                                  mode="user" 
                                                  :userName="props.row.name"
                                                  :userProfileImage="props.row.profile_image" 
                                                  :userIdExternal="props.row.user_id_external"
                                                  :senderIdExternal="null"
                                                  popoverPlacement="right"
                                                  :triggerAvatarSize="25"
                                                  class="mr-2">
                              </userProfilePopover>
                              <div>
                                <span>{{props.row.name}}</span>
                                <span class="d-block mt-1 meta">{{props.row.team_name}} - {{props.row.department_name}}</span>
                              </div>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_moments" :label="$t('loyalty.Moments_received')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/loyalty-moment-icon/common/spark.png/' + clientToken"/>
                              <span>{{props.row.total_moments}} {{props.row.total_moments !== 1 ? $t('sm.Sparks') : $t('sm.Spark')}}</span>
                            </div>
                          </b-table-column>
                          <b-table-column field="total_points_received" :label="$t('loyalty.Coins_received')" width="25%">
                            <div @click="openSidebarRight('user_profile', { user_id_external:  props.row.user_id_external });" class="d-flex align-items-center credits pointer">
                              <img :src="apiBaseUrl + '/v1/common/cdn/file/image/base-dashboard/credits/' + environmentTag + '_credit.png/' + clientToken"/>
                              <span>{{props.row.total_points_received}} {{props.row.total_points_received !== 1 ? $t('common.coins') : $t('common.coin')}}</span>
                            </div>                            
                          </b-table-column>                          
                        </template>
                        <template slot="empty">
                          <div class="text-center">
                            <span>{{ $t('sm.No_sparks_sent_yet') }}</span>
                          </div>
                        </template>
                      </b-table>
                    </CCol>
                  </CRow>
                </template>
              </b-tab-item>
            </b-tabs>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </CCol>
</template>

<script>
import axios from 'axios'
import userProfilePopover from '@/components/common/userProfilePopover.vue';
import loadingSpinner from '@/components/common/loadingSpinner.vue'

export default {
  name: 'MomentsReceivedLeaderboard',
  components: {
    userProfilePopover,
    loadingSpinner
  },  
  data() {
    return {
      apiBaseUrl: null,
      clientToken: null,
      environmentTag: null,
      loadingData: false,
      activeTab: 0,
      momentsReceivedLastMonth: [],
      momentsReceivedLastMonthPaginated: false,
      momentsReceivedLastThreeMonths: [],
      momentsReceivedLastThreeMonthsPaginated: false,
      momentsReceivedLastYear: [],
      momentsReceivedLastYearPaginated: false,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      currentPage: 1,
      perPage: 5,      
    }
  },
  methods: {
    getMomentReceivedLeaderboard() {
      // Start the loader
      this.loadingData = true;
      // Get the points      
      axios.get(process.env.VUE_APP_API_URL + '/v1/insights/loyalty/leaderboard/moments/received')
      .then(res => {
        this.momentsReceivedLastMonth = res.data.data.moments_received_last_month;
        this.momentsReceivedLastThreeMonths = res.data.data.moments_received_last_three_months;
        this.momentsReceivedLastYear = res.data.data.moments_received_last_year;
        // Check if the pagination should be activated
        (this.momentsReceivedLastMonth.length > this.perPage) ? this.momentsReceivedLastMonthPaginated = true : this.momentsReceivedLastMonthPaginated = false;
        (this.momentsReceivedLastThreeMonths.length > this.perPage) ? this.momentsReceivedLastThreeMonthsPaginated = true : this.momentsReceivedLastThreeMonthsPaginated = false;
        (this.momentsReceivedLastYear.length > this.perPage) ? this.momentsReceivedLastYearPaginated = true : this.momentsReceivedLastYearPaginated = false;
        // Close the loader
        this.loadingData = false;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    showInsights(path) {
      this.$router.push({path: 'insights/' + path});
    }
  },
  mounted: function(){
    this.apiBaseUrl = process.env.VUE_APP_API_URL;
    this.clientToken = localStorage.getItem('token');
    if(localStorage.getItem('environmentTag') !== null) this.environmentTag = localStorage.getItem('environmentTag');

    this.getMomentReceivedLeaderboard();
  }
}
</script>